import React, { memo } from 'react';
import { StatementItem } from '@/customTypes/chatStory';
import { getIsShowProfile } from '@service/ChapterService';

import Script from './Script';
import MainCharacter from './MainCharacter';
import Character from './Character';
import FullWidthImage from './FullWidthImage';
import FullWidthTextItem from './FullWidthTextItem';
import ChoiceStatisticsItem from '../../../storyCommon/popup/statistics/ChoiceStatisticsItem';
import ChoiceInputImageItem from './choice/ChoiceInputImageItem';

interface IChatItem {
  statements: StatementItem[];
  statement?: StatementItem;
  characterProfile?: string;
}

const ChatItem = ({ statements, statement, characterProfile }: IChatItem) => {
  return (
    <>
      {statement?.statementType === 'Script' ||
      statement?.statementType === 'Place' ||
      statement?.statementType === 'Time' ? (
        <Script statement={statement} />
      ) : statement?.statementType === 'CharacterTalk' ||
        statement?.statementType === 'CharacterThink' ||
        statement?.statementType === 'MessageImage' ? (
        <Character
          statement={statement}
          isShowProfile={getIsShowProfile(statements, statement)}
          profile={characterProfile}
        />
      ) : statement?.statementType === 'MainCharacterTalk' ||
        statement?.statementType === 'MainCharacterThink' ||
        statement?.statementType === 'MainCharacterMessageImage' ? (
        <MainCharacter
          statement={statement}
          isShowProfile={getIsShowProfile(statements, statement)}
          profile={characterProfile}
        />
      ) : statement?.statementType === 'FullWidthImage' ? (
        <FullWidthImage statement={statement} />
      ) : statement?.statementType === 'FullWidthText' ? (
        <FullWidthTextItem statement={statement} />
      ) : statement?.statementType === 'ChoiceRate' ? (
        <ChoiceStatisticsItem statement={statement} />
      ) : (
        statement?.statementType === 'ChoiceInput' && (
          <ChoiceInputImageItem statement={statement} />
        )
      )}
    </>
  );
};

export default memo(ChatItem);
